<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div class="font-18-30313a font-bold">详细信息</div>
          <div class="line"></div>
          <div>
            <div><span>客户编号：</span>{{info.customerNumber}}</div>
            <div><span>优先级别：</span>{{info.priority}}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><el-checkbox v-model="info.boutique">精品客户</el-checkbox></div>
            <!-- <div><span>优先级别：</span>{{info.priority}}</div> -->
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1">
            <div class="mr-20" v-for="(item, index) in tab" :key="index" v-if="permission.indexOf(item.permission) !== -1">
              <a href="javascript:void (0)" @click="clickA(item.id, index)" class="flex align-center cursor">
                <div class="mr-5" :class="index === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
                <div class="font-bold" :class="index === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{item.name}}</div>
              </a>
            </div>
          </div>
        </div>
        <div class="flex-1 flex-column editInfo">
          <div class="overflow-y flex-1" ref="editInfo">
            <el-scrollbar style="height:100%">
              <div class="main" id="scrollBody">
                <div class="infoItem" id="basis" v-if="permission.indexOf('basicDataShow') !== -1">
                  <div class="font-14-46b8b0 ptb-8 plr-20">基础资料</div>
                  <div class="bg-f9f9fb pt-10 plr-20">
                    <el-form class="group">
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">客户姓名：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.name" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">性<span style="width: 2em; display: inline-block;"></span>别：</div>
                          <el-select class="flex-1" v-model="info.gender" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option label="男" :value="1"></el-option>
                            <el-option label="女" :value="2"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">年<span style="width: 2em; display: inline-block;"></span>龄：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.age" type="number" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40" v-if="permiss.indexOf('showPhoto') !== -1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">联系电话：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.telephone" type="number" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item :class="permiss.indexOf('showPhoto') !== -1 ? 'col-1':'col-2'">
                        <div class="flex align-center">
                          <div class="font-12-30313a">备用电话：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.spareTelephone" type="number" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">客户类型：</div>
                          <el-select class="flex-1" v-model="info.customerType" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.customerType" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">储备时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="请选择时间" format="yyyy.MM.dd " :clearable="false" v-model="info.createTime" :readonly="permission.indexOf('basicDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">来访时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="请选择时间" format="yyyy.MM.dd " :clearable="false" v-model="info.doorCustomerTime" :readonly="permission.indexOf('basicDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-2">
                        <div class="flex align-center">
                          <div class="font-12-30313a">所在方位：</div>
                          <el-select class="flex-1" v-model="info.location" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.location" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">楼盘小区：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.residentialDistrict" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-2 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">详细地址：</div>
                          <div class="flex flex-1 align-center">
                            <el-input placeholder="" class="flex-1 border-radius-right-0" v-model="info.addressStage" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                            <div class="unit">期</div>
                            <el-input placeholder="" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="info.addressBlock" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                            <div class="unit">幢</div>
                            <el-input placeholder="" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="info.addressUnit" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                            <div class="unit">单元</div>
                            <el-input placeholder="" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="info.addressOffice" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                            <div class="unit">楼</div>
                            <el-input placeholder="" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="info.addressNumber" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                            <div class="unit" style="border-right: 1px solid #e2e2e2; border-top-right-radius: 3px; border-bottom-right-radius: 3px;">号</div>
                          </div>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">优先级别：</div>
                          <el-select class="flex-1" v-model="info.priority" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.priority" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <!-- <div class="flex align-center">
                          <el-checkbox v-model="info.boutique">精品客户</el-checkbox>
                        </div> -->
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">客户来源：</div>
                          <el-select class="flex-1" v-model="info.customerSource" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.customerSource" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-4">
                        <div class="flex align-center">
                          <div class="font-12-30313a">来源备注：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.sourceRemark" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">客户关注：</div>
                          <el-select class="flex-1" v-model="info.customerFocus" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.customerFocus" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">建筑面积：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.buildingArea" type="number" :readonly="permission.indexOf('basicDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">㎡</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">使用面积：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.usingArea" type="number" :readonly="permission.indexOf('basicDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">㎡</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">期望造价：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.expectationCost" type="number" :readonly="permission.indexOf('basicDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">房屋类型：</div>
                          <el-select class="flex-1" v-model="info.houseType" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.houseType" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">户<span style="width: 2em; display: inline-block;"></span>型：</div>
                          <el-select class="flex-1" v-model="info.homeType" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.homeType" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">装修风格：</div>
                          <el-select class="flex-1" v-model="info.decorationStyle" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.decorationStyle" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">行业了解：</div>
                          <el-select class="flex-1" v-model="info.industryUnderstanding" :disabled="permission.indexOf('basicDataControl') === -1">
                            <el-option v-for="(item, index) in optionList.industryUnderstanding" :key="index" :label="item.text" :value="item.text"></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">交房时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.deliveryTime" :readonly="permission.indexOf('basicDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">预计上门：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.estimateTime" :readonly="permission.indexOf('basicDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="infoItem" id="design" v-if="permission.indexOf('designDataShow') !== -1">
                  <div class="font-14-46b8b0 ptb-8 plr-20">设计资料</div>
                  <div class="bg-f9f9fb pt-10 plr-20">
                    <el-form class="group">
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">提交预算时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.budgetExamineTime" :readonly="permission.indexOf('designDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">核算通过时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.examinePassTime" :readonly="permission.indexOf('designDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">平面图计划出图时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.designPlanTime" :readonly="true"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">平面图实际出图时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.designActualTime" :readonly="true"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">平面图审核时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.designCheckTime" :readonly="permission.indexOf('designDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">效果图计划出图时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.effectPlanTime" :readonly="true"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">效果图实际出图时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.effectActualTime" :readonly="true"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">效果图审核出图时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.effectCheckTime" :readonly="permission.indexOf('designDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">设计合同号：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.designContractNum" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">设计合同时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.designContractTime" :readonly="permission.indexOf('designDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-5">
                        <div class="flex align-center">
                          <div class="font-12-30313a">设计合同备注：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.designContractRemark" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="infoItem" id="contract" v-if="permission.indexOf('contractDataShow') !== -1">
                  <div class="font-14-46b8b0 ptb-8 plr-20">合同资料</div>
                  <div class="bg-f9f9fb pt-10 plr-20">
                    <el-form class="group">
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">概算合同号：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.budgetEstimateNumber" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">概算时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.budgetContractTime" :readonly="permission.indexOf('contractDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">概算金额：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.budgetEstimateAmount" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">定金金额：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.frontMoneyAmount" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1"></el-form-item>
                      <el-form-item class="col-5">
                        <div class="flex align-center">
                          <div class="font-12-30313a">概算备注：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.budgetEstimateRemark" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">施工合同号：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.projectContractNo" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">合同时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.constructionContractTime" :readonly="permission.indexOf('contractDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">预算金额：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.budgetAmount" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">结算金额：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.settlementAmount" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1"></el-form-item>
                      <el-form-item class="col-5">
                        <div class="flex align-center">
                          <div class="font-12-30313a">合同备注：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.contractRemark" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">分包合同号：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.subContractNo" :readonly="permission.indexOf('contractDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">分包合同签订时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.subContractTime" :readonly="permission.indexOf('contractDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40" v-if="permission.indexOf('showCost') !== -1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">分包预算：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.subBudget" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40" v-if="permission.indexOf('showCost') !== -1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">分包结算：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.subSettlement" type="number" :readonly="permission.indexOf('contractDataControl') === -1">
                            <i slot="suffix" class="el-input__icon">元</i>
                          </el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1"></el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="infoItem" id="project" v-if="permission.indexOf('projectDataShow') !== -1">
                  <div class="font-14-46b8b0 ptb-8 plr-20">工程资料</div>
                  <div class="bg-f9f9fb pt-10 plr-20">
                    <el-form class="group">
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">计划完工时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.contractFinishTime" :readonly="permission.indexOf('projectDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">实际开工时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.actualStartTime" :readonly="permission.indexOf('projectDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">实际完工时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.actualEndTime" :readonly="permission.indexOf('projectDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="infoItem" id="afterSales" v-if="permission.indexOf('aftersaleDataShow') !== -1">
                  <div class="font-14-46b8b0 ptb-8 plr-20">售后资料</div>
                  <div class="bg-f9f9fb ptb-10 plr-20">
                    <el-form class="group">
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">保修卡编号：</div>
                          <el-input placeholder="请输入" class="flex-1" v-model="info.afterSalesNumber" :readonly="permission.indexOf('aftersaleDataControl') === -1"></el-input>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1 mr-40">
                        <div class="flex align-center">
                          <div class="font-12-30313a">售后开始时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.afterSalesStartTime" :readonly="permission.indexOf('aftersaleDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item class="col-1">
                        <div class="flex align-center">
                          <div class="font-12-30313a">售后结束时间：</div>
                          <el-date-picker class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="info.afterSalesEndTime" :readonly="permission.indexOf('aftersaleDataControl') === -1"></el-date-picker>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="w-100" :style="{height: blank}"></div>
              </div>
            </el-scrollbar>
          </div>
          <div class="bottom flex justify-center">
            <div class="btn-30-bg-46b8b0-s" @click="onSave">保存</div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'detailInfo',
  components: {},
  data () {
    return {
      id: null,
      parent: null,
      tabIndex: -1,
      num: 1,
      tab: [{
        name: '基础资料',
        id: '#basis',
        permission: 'basicDataShow'
      }, {
        name: '设计资料',
        id: '#design',
        permission: 'designDataShow'
      }, {
        name: '合同资料',
        id: '#contract',
        permission: 'contractDataShow'
      }, {
        name: '工程资料',
        id: '#project',
        permission: 'projectDataShow'
      }, {
        name: '售后资料',
        id: '#afterSales',
        permission: 'aftersaleDataShow'
      }],
      blank: 0,
      info: {},
      optionList: {},
      permission: [],
      permiss: []
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.getOption()
    this.getInfo()
    this.getPermission()
  },
  methods: {
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          res.data.data.boutique = (res.data.data.boutique === 1)
          this.info = res.data.data
          console.log(this.info.boutique)
        }
      })
    },
    onSave () {
      this.info.boutique = this.info.boutique ? 1 : 0
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/modify`, {
        ...this.info
      }).then(res => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.getInfo()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: this.parent,
        parentGroup: 'customerClassify'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
          this.$nextTick(() => {
            let height = this.$refs.editInfo.offsetHeight // 获取滚动的总高度
            let lastHeight = document.querySelectorAll('.infoItem')[document.querySelectorAll('.infoItem').length - 1].offsetHeight // 获取最后一个元素的高度
            this.blank = (height - lastHeight) + 'px' // 空白区域高度
          })
        }
      })
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/getSubmitButtonStr`, {
        parent: this.parent
      }).then(res => {
        if (res.data.success) {
          this.permiss = res.data.data.split(',')
        }
      })
    },
    getOption () {
      this.axios.post(`${this.$store.state.API_URL_9010}/param/filterList`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.optionList = res.data.data
        }
      })
    },
    clickA (id, index) {
      let item = document.getElementById(id.replace('#', ''))
      this.tabIndex = index
      item.scrollIntoView({block: 'start', behavior: 'smooth'})
      return false
    },
    onClose () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-main{
    padding: 0;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .editInfo /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 20px;
    border-radius: 4px;
  }
  .overflow-y{
    overflow-y: auto;
  }
  .editInfo{
    border-radius: 4px;
    background: #fff;
    text-align: left;
    height: 0;
  }
  .editInfo .bottom{
    border-top: 1px solid #e2e2e2;
    padding: 10px;
  }
  .editInfo /deep/ .el-form-item{
    margin-bottom: 10px;
  }
  .col-1{
    width: calc((100% - 160px) / 5);
    min-height: 31px;
  }
  .col-2{
    width: calc(((100% - 160px) / 5) * 2 + 40px);
    min-height: 31px;
  }
  .col-4{
    width: calc(((100% - 160px) / 5) * 4 + 120px);
    min-height: 31px;
  }
  .col-5{
    width: 100%;
    min-height: 31px;
  }
  .group{
     overflow: hidden;
   }
  .group > div{
    float: left;
  }
  .group /deep/ .el-input--prefix .el-input__inner{
    padding-left: 10px;
  }
  .group /deep/ .el-input__prefix{
    left: auto;
    right: 5px;
  }
  .group /deep/ .el-input__suffix{
    right: 10px;
  }
  .el-select /deep/ .el-input__suffix{
    right: 5px;
  }
  .group /deep/ .el-input__icon{
    font-size: 12px;
    line-height: 30px;
    color: #30313a;
    font-style: normal;
  }
  .group /deep/ input::-webkit-outer-spin-button,
  .group /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .group /deep/ input[type="number"]{
    -moz-appearance: textfield;
  }
  .unit{
    font-size: 12px;
    color: #b9b9b9;
    border: solid 1px #e2e2e2;
    border-left: 0;
    border-right: 0;
    background-color: #f3f4f7;
    padding:  0 10px;
    height: 30px;
    line-height: 30px;
  }
  .border-radius-left-0 /deep/ .el-input__inner{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

  }
  .border-radius-right-0 /deep/ .el-input__inner{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/detailInfo.vue